module.exports = __webpack_public_path__ + "img/3.9bd85da2.png";